module.exports = __webpack_public_path__ + "static/kilo-56a1b34a706a8cd275e65d9a069344d6.jpg";